module.exports = __webpack_public_path__ + "img/bjnum-poprank-border-1.7abcc933.png";